import * as React from 'react';

import { ApolloProvider } from 'react-apollo';
import { UserContextProvider, IUser } from '@reverbdotcom/commons/dist/components/user_context_provider';
import { URLContext, buildUrlContextObject } from '@reverbdotcom/commons/dist/url_context';
import { RoutingResult, RoutingResultContext } from '@reverbdotcom/commons/dist/routing_result';
import { buildClient } from './lib/apollo_client';

const RApolloProvider = ApolloProvider as any;

export interface IProps {
  user: IUser;
  client: ReturnType<typeof buildClient>;
  url: string;
  routingResult: RoutingResult;
  referer: string;
  children: React.ReactNode;
}

export default function AppProvider(props: IProps) {
  return (
    <URLContext.Provider value={buildUrlContextObject(props.url, props.referer)}>
      <RoutingResultContext.Provider value={props.routingResult || {}}>
        <UserContextProvider user={props.user}>
          <RApolloProvider client={props.client}>
            {props.children}
          </RApolloProvider>
        </UserContextProvider>
      </RoutingResultContext.Provider>
    </URLContext.Provider>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/app_provider.tsx